

export class RespCompanyList {
    constructor(status) {
        this.status = status;
    }
    fromJson(jsonDate) {
        this.status = jsonDate.status
        this.list = []
        jsonDate.list.map((json) => {
            var company = new RespCompany()
            company.fromJson(json)
            this.list.push(company)
        })

        this.count = jsonDate.count
        this.disableCount = jsonDate.disableCount
        this.enableCount = jsonDate.enableCount
    }
}

export class RespCompany {
    constructor({ companyId, companyName, texIdNumber, businessArea, note, isDisable }) {
        if (companyId !== undefined)
            this.companyId = companyId
        this.companyName = companyName
        if (texIdNumber !== undefined)
            this.texIdNumber = texIdNumber
        if (businessArea !== undefined)
            this.businessArea = businessArea
        this.note = note
        this.isDisable = isDisable
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        //console.log(jsonDate)
        this.companyId = jsonDate.companyId
        this.companyName = jsonDate.companyName
        this.texIdNumber = jsonDate.texIdNumber
        this.businessArea = jsonDate.businessArea
        this.note = jsonDate.note
        this.applyId = jsonDate.applyId
        this.isDisable = jsonDate.isDisable
        this.firstEmployee = jsonDate.firstEmployee
    }

    toString() {
        return 'Name: ' + this.fullName + ', Age:' + this.age
    }
}

export class ReqCompanyFirstEmployee {
    constructor({ companyId, firstEmployee}) {
        this.companyId = companyId
        this.firstEmployee = firstEmployee
    }

    fromJson(jsonDate){
        this.companyId = jsonDate.companyId
        this.firstEmployee = jsonDate.firstEmployee
    }
}